import {
  invoiceStatusLabel,
  invoiceStatusVariant,
} from "@/domain/invoices/invoiceStatus";
import { cn } from "@/utils/cn";

const VARIANT_CLASS = {
  paid: "bg-emerald-50 text-emerald-900 ring-emerald-200",
  open: "bg-amber-50 text-amber-900 ring-amber-200",
  void: "bg-stone-100 text-stone-600 ring-stone-200",
  neutral: "bg-stone-100 text-stone-600 ring-stone-200",
};

export function InvoiceStatusBadge({ status }: { status: string }) {
  const variant = invoiceStatusVariant(status);
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2 py-0.5 text-xs font-semibold capitalize ring-1 ring-inset",
        VARIANT_CLASS[variant],
      )}
    >
      {invoiceStatusLabel(status)}
    </span>
  );
}
